export default __webpack_public_path__ + "static/media/add-user-16px.dc3b45af.svg";